import { Observable } from 'rxjs';
import { CardCartItem } from '../../models/card/card-cart-item.model';
import { IListResult } from '../list-result/list-result.interface';
import { ICardItem } from './card-item-interface';

export abstract class ICardSource {

  abstract getList(): Observable<IListResult<ICardItem>>;
  abstract addToCart(item: CardCartItem): Observable<Response>;

}
